import { requestApiPost } from "../../api";
import { SET_USER_LOCATION } from "../../appConstants/APIEndpoint";
import { store } from "../../store";
import { showLocationModal } from "../../store/actions/actions";
import {
  BANNED_GAMES,
  BANNED_STATE,
  FOUND_STATE,
  GAME_NAME,
} from "../../utils/helpers/constants";
import { _get, _replace } from "../../utils/helpers/zupeeLodash";

export const LOCATION_PERMISSION_STATUS = {
  GRANTED: "granted", // User has allowed location access
  DENIED: "denied", // User has denied location access
  PROMPT: "prompt", // User hasn't made a decision yet (NOT_ASKED)
  BLOCKED: "blocked", // User has blocked location access in browser settings
  NOT_ASKED: "not_asked", // Initial state before asking for permission
  UNAVAILABLE: "unavailable", // Geolocation is not supported by the browser
  RESTRICTED: "restricted", // Location access is restricted by the browser
}

export const LOC_REGISTER_TOURNAMENT = "REGISTER_TOURNAMENT";

export type LocationPermissionStatusType =
  (typeof LOCATION_PERMISSION_STATUS)[keyof typeof LOCATION_PERMISSION_STATUS];

export const isLocationPermissionGrantedWeb = async (): Promise<boolean> => {
  if (!navigator.permissions || !navigator.permissions.query) {
    // Fallback for browsers that don't support Permissions API
    return navigator.geolocation !== undefined;
  }

  try {
    const result = await navigator.permissions.query({ name: "geolocation" });
    return result.state === LOCATION_PERMISSION_STATUS.GRANTED;
  } catch (error) {
    console.error("Error checking location permission:", error);
    return false;
  }
};

export const generateSubHeadingHtml = (
  stringWithPlaceHolder: string,
  foundState: string,
  bannedStates: string,
  gameName: string,
  bannedGames: string
): string => {
  let subHeading = _replace(stringWithPlaceHolder, "\n", "<br/>");
  subHeading = _replace(subHeading, FOUND_STATE, `<b>${foundState}</b>`);
  subHeading = _replace(subHeading, BANNED_STATE, `<b>${bannedStates}</b>`);
  subHeading = _replace(subHeading, GAME_NAME, `<b>${gameName}</b>`);
  subHeading = _replace(subHeading, BANNED_GAMES, `<b>${bannedGames}</b>`);
  return `<p style='text-align:center;font-size:16px;'>${subHeading}</p>`;
};

export const storeAddressAtBackend = (
  locationObj: any,
  callback: () => void
) => {
  if (!navigator.geolocation) {
    console.error("Geolocation is not supported by this browser");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const lat = position.coords.latitude;
      const lng = position.coords.longitude;

      try {
        const body = {
          lat,
          lng,
          action: locationObj?.action,
          entryFee: locationObj?.entryFee,
          gameName: locationObj?.gameName,
        };

        const res = (await requestApiPost(SET_USER_LOCATION, body)) || {};

        if (_get(res, "response.data.available")) {
          callback();
        } else {
          store.dispatch(showLocationModal(res?.response?.data));
        }
      } catch (error) {
        console.error("Error storing location:", error);
      }
    },
    (error) => {
      console.error("Error getting location:", error.message);
      store.dispatch(showLocationModal({ error: "Unable to get location" }));
    },
    {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    }
  );
};
